import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_FILTERS_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_GET_EMPLOYEES_FILTERS, KEY_GET_EMPLOYEES_FILTERS } from '../constants';
import { MOCK_RESPONSE_GET_EMPLOYEES_FILTERS } from '../mocks';

type RequestEmployeesFilters = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_FILTERS_PATH_KEY
>['request']['path'];

type ResponseGetEmployeesFilters = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_FILTERS_PATH_KEY
>['response']['body'];

export type CallParamsGetEmployeesFilters = Omit<RequestEmployeesFilters, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetEmployeesFilters = ResponseGetEmployeesFilters;

type CallErrorGetEmployeesFilters = {
  message: string;
  code: number;
};

type CallSelectorsGetEmployeesFilters = unknown;

export const getEmployeesFiltersCall = createGeneralCall<
  CallParamsGetEmployeesFilters,
  CallResponseGetEmployeesFilters,
  CallErrorGetEmployeesFilters,
  CallSelectorsGetEmployeesFilters
>({
  id: KEY_GET_EMPLOYEES_FILTERS,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_EMPLOYEES_FILTERS(org as unknown as string);
  },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_EMPLOYEES_FILTERS : undefined,
});
